import React from 'react';
import styled from 'styled-components';
import { Column, ColumnProps } from 'primereact/column';
import { FieldPanelFullWidth } from 'styles/v2/Styles.styled';
import { AdminEpdSearchResult } from 'types/types';
import AdminSearchResultsGrid from '../search/AdminSearchResultsGrid';

interface Props {
  rows: AdminEpdSearchResult[];
  columns: ColumnProps[];
  onPageChange: (event: { page: number; rows: number }) => void;
  pagination: {
    page: number;
    pageSize: number;
  };
  totalCount: number;
  isLoading: boolean;
}

const AdminSearchEpdResultsTable: React.FC<Props> = ({
  rows,
  columns,
  onPageChange,
  pagination,
  totalCount,
  isLoading,
}) => {
  return (
    <FieldPanelFullWidth>
      <Container>
        <AdminSearchResultsGrid
          key={`epd-search-results-table-${totalCount}-${isLoading}`} // Key to force re-render on data change
          value={rows}
          totalRecords={totalCount}
          pageIndex={pagination.page}
          pageSize={pagination.pageSize}
          tableStyle={{ minWidth: '50rem' }}
          scrollable
          loading={isLoading}
          onPageChange={(ev) => onPageChange({ page: ev.pageIndex, rows: ev.pageSize })}
          pageSizeOptions={[10, 20, 50]}
        >
          {columns.map((col) => (
            <Column key={col.field} {...col} />
          ))}
        </AdminSearchResultsGrid>
      </Container>
    </FieldPanelFullWidth>
  );
};

const Container = styled.div`
  overflow-x: hidden;
`;

export default AdminSearchEpdResultsTable;
